import { useState } from 'react';
import { Button, Input, showToast } from '@attentive-platform/stem-ui';
import { FormContainer } from '../../../styled';
import { useChangePassword } from '../../../Utils/services';
import { isValidEmail } from '../../../Utils/HelperFunctions';

const DEFAULT_STATE = { email: '', password: '' };

export const ChangePassword = () => {
  const [formData, setFormData] = useState(DEFAULT_STATE);
  const { mutate, loading } = useChangePassword();

  const onSubmitHandler = () => {
    const data = { email: formData.email, new_password: formData.password };
    mutate(
      { data },
      {
        onSuccess: () => {
          showToast('Password changed successfully!');
          setFormData(DEFAULT_STATE);
        },
        onError: error => {
          showToast(error, 'error');
        }
      }
    );
  };

  const onChangeHandler = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const disabledCta = !formData.email || !formData.password || !isValidEmail(formData.email);

  return (
    <FormContainer>
        <Input
          label='Email'
          type='email'
          name='cp-page-email'
          fullWidth
          placeholder='Enter email address'
          value={formData.email}
          onChange={e => onChangeHandler('email', e.target.value)}
          required
          className='mb-2'
        />
        <Input
          label='New Password'
          type='password'
          name='cp-page-password'
          fullWidth
          placeholder='Enter new password'
          value={formData.password}
          onChange={e => onChangeHandler('password', e.target.value)}
          required
          className='mb-2'
        />
      <div className='flex justify-end'>
        <Button
          disabled={disabledCta}
          loading={loading}
          color='primary'
          size='medium'
          variant='contained'
          onClick={onSubmitHandler}
          className='text-base'>
          Change password
        </Button>
      </div>
    </FormContainer>
  );
};
